/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Legacy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetUserCCsResponseItems
 */
export interface GetUserCCsResponseItems {
    /**
     * 
     * @type {number}
     * @memberof GetUserCCsResponseItems
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof GetUserCCsResponseItems
     */
    aktid: number;
    /**
     * 
     * @type {string}
     * @memberof GetUserCCsResponseItems
     */
    date: string;
    /**
     * 
     * @type {string}
     * @memberof GetUserCCsResponseItems
     */
    subject: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCCsResponseItems
     */
    isBold: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetUserCCsResponseItems
     */
    icon: string;
    /**
     * 
     * @type {string}
     * @memberof GetUserCCsResponseItems
     */
    resp: string;
    /**
     * 
     * @type {number}
     * @memberof GetUserCCsResponseItems
     */
    priority: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCCsResponseItems
     */
    hasattachment: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetUserCCsResponseItems
     */
    aktname: string;
    /**
     * 
     * @type {number}
     * @memberof GetUserCCsResponseItems
     */
    akttype: number;
    /**
     * 
     * @type {string}
     * @memberof GetUserCCsResponseItems
     */
    sender: string;
    /**
     * 
     * @type {string}
     * @memberof GetUserCCsResponseItems
     */
    summary: string;
    /**
     * 
     * @type {number}
     * @memberof GetUserCCsResponseItems
     */
    todotype: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCCsResponseItems
     */
    isrecurring?: boolean;
}

export function GetUserCCsResponseItemsFromJSON(json: any): GetUserCCsResponseItems {
    return GetUserCCsResponseItemsFromJSONTyped(json, false);
}

export function GetUserCCsResponseItemsFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUserCCsResponseItems {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'aktid': json['aktid'],
        'date': json['date'],
        'subject': json['subject'],
        'isBold': json['isBold'],
        'icon': json['icon'],
        'resp': json['resp'],
        'priority': json['priority'],
        'hasattachment': json['hasattachment'],
        'aktname': json['aktname'],
        'akttype': json['akttype'],
        'sender': json['sender'],
        'summary': json['summary'],
        'todotype': json['todotype'],
        'isrecurring': !exists(json, 'isrecurring') ? undefined : json['isrecurring'],
    };
}

export function GetUserCCsResponseItemsToJSON(value?: GetUserCCsResponseItems | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'aktid': value.aktid,
        'date': value.date,
        'subject': value.subject,
        'isBold': value.isBold,
        'icon': value.icon,
        'resp': value.resp,
        'priority': value.priority,
        'hasattachment': value.hasattachment,
        'aktname': value.aktname,
        'akttype': value.akttype,
        'sender': value.sender,
        'summary': value.summary,
        'todotype': value.todotype,
        'isrecurring': value.isrecurring,
    };
}


